/**
 * @fileoverview Shared avatar helpers for the mail surfaces (MOR-529).
 *
 * Deterministic soft-pastel tint + initials per address so the same sender
 * looks identical across the list pane, reader, and sent rows.
 */

const AVATAR_TINTS = [
  "bg-emerald-100 text-emerald-800 dark:bg-emerald-950 dark:text-emerald-300",
  "bg-sky-100 text-sky-800 dark:bg-sky-950 dark:text-sky-300",
  "bg-amber-100 text-amber-800 dark:bg-amber-950 dark:text-amber-300",
  "bg-violet-100 text-violet-800 dark:bg-violet-950 dark:text-violet-300",
  "bg-rose-100 text-rose-800 dark:bg-rose-950 dark:text-rose-300",
  "bg-teal-100 text-teal-800 dark:bg-teal-950 dark:text-teal-300",
];

export function avatarTint(seed: string): string {
  const hash = Array.from(seed).reduce(
    (acc, ch) => (acc * 31 + ch.charCodeAt(0)) | 0,
    0,
  );
  return AVATAR_TINTS[Math.abs(hash) % AVATAR_TINTS.length];
}

export function initialsFor(source: string): string {
  const words = source
    // Drop email domains ("morgan@…" → "morgan").
    .replace(/@.*$/, "")
    // Drop parenthetical/bracketed qualifiers so labels like
    // "Morgan (this mailbox)" don't leak a "(" into the initials.
    .replace(/[([{].*$/, "")
    .split(/[\s._-]+/)
    // Keep only letters/numbers per word so stray punctuation is ignored.
    .map((w) => w.replace(/[^\p{L}\p{N}]/gu, ""))
    .filter(Boolean);
  if (words.length === 0) return "?";
  if (words.length === 1) return words[0].slice(0, 2).toUpperCase();
  return (words[0][0] + words[1][0]).toUpperCase();
}
